import React, { useContext, useMemo } from "react";
import SupplierVendors from "../SupplierVendors/SupplierVendors";
import { SocketContext } from "../../../contexts/SocketContext";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UiContext from "../../../contexts/UiContext";
import { useLocation, useNavigate } from "react-router-dom";
import ViewAccessService from "@services/ViewAccessService";
import { hasEditAccess } from "@services/ScreenOptionsService";
import ScreenOptionsEnum from "@models/ScreenOptionsEnum";

type Props = {};

export const SupplierVendorsWrapper = (props: Props) => {
    const socket = useContext(SocketContext)!;
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const uiContext = useContext(UiContext);

    const location = useLocation();
    const navigate = useNavigate();

    const isReadOnly = useMemo(() => {
        return !hasEditAccess(ScreenOptionsEnum.ACCOUNTS, userModel, supplierModel, ViewAccessService.UsersVendors);
    }, [userModel, supplierModel]);

    return (
        <SupplierVendors
            socket={socket}
            setActivityIndicator={uiContext.setActivityIndicator}
            notifyFn={uiContext.notifyFn}
            setSidebarComponent={uiContext.setSidebarComponent}
            toggleSidebar={uiContext.toggleSidebar}
            supplierModel={supplierModel}
            userModel={userModel}
            location={location}
            history={navigate}
            showHiddenFeatures={uiContext.showHiddenFeatures}
            isReadOnly={isReadOnly}
        />
    );
};
